/** Built-in role codes cloned per organization at signup. */
export const STANDARD_ROLE_CODES = [
  'ORGANIZATION_OWNER',
  'STORE_MANAGER',
  'CASHIER',
  'INVENTORY_MANAGER',
  'CRM_CUSTOMER_SUPPORT',
  'CRM_MANAGER',
  'HR_EXECUTIVE',
  'HR_MANAGER',
  'FINANCE_EXECUTIVE',
  'FINANCE_MANAGER',
] as const;

export type StandardRoleCode = (typeof STANDARD_ROLE_CODES)[number];

/** Permission codes for quick custom-role presets (matches built-in templates). */
export const ROLE_PRESET_PERMISSIONS: Record<string, string[]> = {
  CASHIER: [
    'PRODUCT_VIEW',
    'BILLING_VIEW',
    'BILLING_CREATE',
    'CUSTOMER_VIEW',
    'DASHBOARD_VIEW',
    'STORE_VIEW',
  ],
  STORE_MANAGER: [
    'ORG_VIEW',
    'STORE_VIEW',
    'STORE_MANAGE',
    'EMPLOYEE_VIEW',
    'PRODUCT_VIEW',
    'PRODUCT_MANAGE',
    'INVENTORY_VIEW',
    'INVENTORY_MANAGE',
    'BILLING_VIEW',
    'BILLING_CREATE',
    'BILLING_RETURN',
    'CUSTOMER_VIEW',
    'CUSTOMER_MANAGE',
    'REPORT_VIEW',
    'DASHBOARD_VIEW',
    'ROLE_VIEW',
    'ROLE_MANAGE',
  ],
  INVENTORY_MANAGER: [
    'PRODUCT_VIEW',
    'PRODUCT_MANAGE',
    'INVENTORY_VIEW',
    'INVENTORY_MANAGE',
    'REPORT_VIEW',
    'DASHBOARD_VIEW',
    'STORE_VIEW',
  ],
  CRM_CUSTOMER_SUPPORT: ['CRM_VIEW', 'DASHBOARD_VIEW'],
  CRM_MANAGER: ['CRM_VIEW', 'CRM_MANAGE', 'CRM_PIPELINE_MANAGE', 'CRM_CAMPAIGN_MANAGE', 'CRM_ANALYTICS_VIEW'],
  HR_EXECUTIVE: ['HR_VIEW', 'DASHBOARD_VIEW'],
  HR_MANAGER: ['HR_VIEW', 'HR_MANAGE'],
  FINANCE_EXECUTIVE: ['FINANCE_VIEW', 'DASHBOARD_VIEW'],
  FINANCE_MANAGER: ['FINANCE_VIEW', 'FINANCE_MANAGE'],
};

export const ROLE_PRESET_LABELS: { key: string; label: string; hint: string }[] = [
  { key: 'CASHIER', label: 'POS Cashier', hint: 'Checkout, customers, held bills' },
  { key: 'STORE_MANAGER', label: 'POS Manager', hint: 'Store ops, billing, products, reports' },
  { key: 'INVENTORY_MANAGER', label: 'Inventory', hint: 'Stock, suppliers, products' },
  { key: 'CRM_CUSTOMER_SUPPORT', label: 'CRM Customer Support', hint: 'View CRM records' },
  { key: 'CRM_MANAGER', label: 'CRM Manager', hint: 'Full CRM access' },
  { key: 'HR_EXECUTIVE', label: 'HR Executive', hint: 'HR operations' },
  { key: 'HR_MANAGER', label: 'HR Manager', hint: 'Full HRMS access' },
  { key: 'FINANCE_EXECUTIVE', label: 'Finance Executive', hint: 'Finance operations' },
  { key: 'FINANCE_MANAGER', label: 'Finance Manager', hint: 'Full finance access' },
];
